import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    grievances: [],
    totalItems:0,
    grievance: {}
};

const getters = {
    index: state => grievanceId => state.grievances.findIndex(i => i.grievanceId === grievanceId)
};

const mutations = {
    setGrievances: (state, r) => (state.grievances = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    setGrievance: (state, r) => (state.grievance = r),
    add: (state, r) => state.grievances.unshift(r),
    edit: (state, { index, r }) => state.grievances.splice(index, 1, r),
    delete: (state, index) => state.grievances.splice(index, 1),
    approval: (state, index) => state.grievances[index].status = status.active,

};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.grievances.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setGrievances", response.data.grievances);
            commit("setTotalItems", response.data.totalItems);

           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            let formData = new FormData()
            formData.append("grievanceDate", payload.grievanceDate);
            formData.append("employeeId", payload.employeeId);
            formData.append("grievanceTypeId", payload.grievanceTypeId);
            formData.append("startingDate", payload.startingDate);
            formData.append("correlatorId", payload.correlatorId);
            formData.append("correlatorDate", payload.correlatorDate);
            formData.append("remarks", payload.remarks);
            formData.append("attachmentFile", payload.attachmentFile);
            
            startLoading()
            const response = await dataService.grievances.add(formData);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            commit("add", response.data.grievance);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.grievances.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async approval({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.grievances.approval(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("approval", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setGrievance", {});
            startLoading()
            const response = await dataService.grievances.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setGrievance", response.data.grievance);
         
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.grievances.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.grievance);
           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            let formData = new FormData()
            formData.append("grievanceDate", payload.grievanceDate);
            formData.append("employeeId", payload.employeeId);
            formData.append("startingDate", payload.startingDate);
            formData.append("correlatorId", payload.correlatorId);
            formData.append("correlatorDate", payload.correlatorDate);
            formData.append("remarks", payload.remarks);
            formData.append("attachmentFile", payload.attachmentFile);
            
            startLoading()
            const response = await dataService.grievances.edit(id, formData);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
         
            const index = getters.index(id);
            commit("edit", { index, r: response.data.grievance });

          /*  return Promise.resolve()*/
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },

    async employeesSearch(_, employeeId) {
        try {

            // startLoading()
            const response = await dataService.grievances.employeesSearch(employeeId);
            // stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            } 
       
            return Promise.resolve(response.data.employee);

        } catch (error) {
            // stopLoading()
            catchHandler(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
